import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'store/hook';
import { SWToolTip } from 'components/SWToolTip';
import { useTranslation } from 'react-i18next';

export const NotificationCounter = () => {
  const { t } = useTranslation();
  const [unReadNotificationsCount, setUnReadNotificationsCount] =
    React.useState<number>(0);
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate('/notifications');
  };

  const { notifications } = useAppSelector(
    (state) => state.ruleNotificationsReducer
  );

  React.useEffect(() => {
    const unReadNotifications = notifications.filter((ntfc) => !ntfc.isRead);
    setUnReadNotificationsCount(unReadNotifications.length);
  }, [notifications]);

  return (
    <SWToolTip title={t('sensor_based_notifications')}>
      <button className="notification-btn" onClick={handleRedirect}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Left ringing arc aligned with bell curve */}
          <path
            d="M4 9C4 6 5 5 6 3"
            stroke="white"
            strokeWidth="1.8"
            strokeLinecap="round"
          />

          {/* Right ringing arc aligned with bell curve */}
          <path
            d="M20 9C20 7 19 5 18 3"
            stroke="white"
            strokeWidth="1.8"
            strokeLinecap="round"
          />

          {/* Bell body */}
          <path
            d="M12 2C8.7 2 6 4.7 6 8v5l-1.5 1.5a1 1 0 0 0 .7 1.7h13.6a1 1 0 0 0 .7-1.7L18 13V8c0-3.3-2.7-6-6-6z"
            fill="white"
          />

          {/* Bell clapper */}
          <circle cx="12" cy="18" r="2" fill="white" />

          {/* Exclamation mark using background color (cutout illusion) */}
          <line
            x1="12"
            y1="6"
            x2="12"
            y2="10"
            stroke="#0f1f3a"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
          <circle cx="12" cy="13.5" r="1.2" fill="#0f1f3a" />
        </svg>

        {unReadNotificationsCount > 0 && (
          <span className="notification-badge">{unReadNotificationsCount}</span>
        )}
      </button>
    </SWToolTip>
  );
};
